import React from 'react'

const Stimulsoft = React.memo(({ mrt, data, customHeight, title }) => {
  // const main = new window.Stimulsoft.Report.StiReport()
  const main = new window.Stimulsoft.Report.StiReport()

  main.loadFile('/assets/reports/' + mrt)
  main.dictionary.databases.clear()
  main.dictionary.synchronize()

  if (title && typeof title === 'string' && title.trim().length > 0) {
    main.reportName = title
  }

  if (data) {
    const item = new window.Stimulsoft.System.Data.DataSet('ds')
    item.readJson(data)
    main.regData('ds', 'ds', item)
  };

  const options = new window.Stimulsoft.Viewer.StiViewerOptions()
  options.exports.showExportToExcel2007 = true
  options.appearance.backgroundColor = window.Stimulsoft.System.Drawing.Color.white
  options.appearance.scrollbarsMode = true

  const viewer = new window.Stimulsoft.Viewer.StiViewer(options, 'StiViewer', false)
  viewer.report = main
  setTimeout(() => {
    window.Stimulsoft.Base.StiLicense.key = '6vJhGtLLLz2GNviWmUTrhSqnOItdDwjBylQzQcAOiHlFHCwE/nKJ3R9xD1smpZaRd7BfkwFg/CXN3PSquZOblA7F9j' +
        'cFsD8kEx6xLm2tf/6zDBygtZlCA7soSzQQZrl2/9xm9p6XOqnuP6PbJ8aHbahf1aLaTsEInc5P0TFvdC3jomyBzvmN' +
        'RyGjd3zh0xVpfjCzTsH54XMKp9n6TIqpX46Sod74sUMdR5naWV24bTcprCEbeGtEOzQBoKfLRTRdD4fEUuVp2pM35h' +
        'ykPkTTT+T6wRo6mT1qyoIhDXizP1KvXq9NJglu0TzAL/4LUSh5gppIWQ4IaFB9MDYPGYD5w2MiXGalKk4XODYJ8vgF' +
        'mx3NGQC+51qeY48Ty9VQa00QTj2IATMXBnksReTiO2TKvI255JcsuFIbzJe/YilVaBPQgdWHQDrSepme+MtOH79pZW' +
        '3MiUNQKstP9CJCVkJTkFYftxPIJEcH+gh3I64CGD2YDqOEjC53mgXWqGm2S7/EP6z/S77Hf8YO2aB2zUCmn64hFabs' +
        'AbXSbwl14oguo6E='

    viewer.renderHtml('viewerContent')
    document.getElementById('StiViewer').style.height = (document.getElementsByClassName('bp3-dialog')[0].clientHeight - (customHeight || 80)) + 'px'
  }, 500)

  return (
    <div id='viewerContent' />
  )
})

export default Stimulsoft
